<rid-mechanic-background />

<rid-mechanic-wrapper>
  <rid-top-bar [progress]="numberIndex()" [steps]="numbers().length" class="block w-full" name="Eierdozen" />

  <rid-mechanic-content>
    @if (state() === 'QUESTION') {
      <div class="grid place-items-center">
        <p class="font-family-din text-8xl font-semibold text-white">{{ number()[0] }} + {{ number()[1] }} = ?</p>
      </div>
    }

    @if (['TENTH', 'SINGLE', 'CARRY', 'WRITE'].includes(state())) {
      <div class="flex size-full flex-col items-center gap-8 p-8">
        <div class="grid size-full grid-cols-2 gap-16">
          <div class="flex w-full max-w-3xl shrink-0 gap-4">
            <div class="w-24">
              <div [ngClass]="{ 'h-40': state() === 'TENTH', 'h-80': state() === 'SINGLE', 'h-120': state() === 'CARRY' }"></div>
              <div class="anim-bounce-ltr flex h-40 items-center text-8xl font-bold text-emerald-500">→</div>
            </div>

            <div class="flex size-full flex-col text-white">
              <div
                [ngClass]="{ 'text-emerald-500': state() === 'WRITE' }"
                class="font-family-din grid h-40 w-full grid-cols-4 items-center gap-4 text-8xl font-semibold"
              >
                <div class="col-span-3 grid h-full grid-cols-2 items-center gap-2 border-b-4 border-white">
                  <div class="text-end">{{ number()[0] }} +</div>
                  <div class="flex h-full w-full items-center gap-2">
                    <div
                      [ngClass]="{ 'border-transparent!': state() === 'WRITE' }"
                      class="flex h-full w-full items-center justify-end rounded-t-lg border-4 border-b-0 border-dotted border-white bg-white/30 p-2 text-emerald-500"
                    >
                      @let str = number()[1].toString();

                      <span [ngClass]="{ 'border-b-emerald-500': state() === 'TENTH' }" class="border-b-5 border-transparent">
                        {{ str[0] }}
                      </span>
                      <span
                        [ngClass]="{ 'border-b-emerald-500': ['SINGLE', 'CARRY'].includes(state()) }"
                        class="border-b-5 border-transparent"
                      >
                        {{ str[1] }}
                      </span>
                    </div>
                    <div>=</div>
                  </div>
                </div>

                <div class="flex min-w-0 items-center justify-end self-stretch">
                  @if (state() === 'WRITE') {
                    <div
                      [ngClass]="{ 'border-red-500! ring-red-500/50!': isWrong(), 'anim-shake': shake() }"
                      class="ring-primary-400/50 flex size-full items-center justify-end gap-2 rounded-lg border-4 border-dotted border-white bg-white/30 px-2 ring-6"
                    >
                      {{ userAnswer() }}
                    </div>
                  } @else {
                    ?
                  }
                </div>
              </div>

              <div
                [ngClass]="{ 'text-emerald-500': state() === 'TENTH' }"
                class="font-family-din grid h-40 w-full grid-cols-4 items-center gap-4 text-8xl"
              >
                <div class="col-span-3 grid h-full grid-cols-2 items-center gap-2">
                  <div class="text-end">{{ number()[0] }} +</div>
                  <div class="flex h-full w-full items-center gap-2">
                    <div
                      [ngClass]="{
                        'border-b-4': state() === 'TENTH',
                        'border-transparent!': state() === 'WRITE',
                        'rounded-b-lg': state() === 'TENTH',
                      }"
                      class="flex h-full w-full items-center justify-end border-4 border-t-0 border-b-0 border-dotted border-white bg-white/30 p-2"
                    >
                      {{ tenths() * 10 }}
                    </div>
                    <div>=</div>
                  </div>
                </div>

                <div class="flex min-w-0 items-center justify-end self-stretch">
                  <rid-egg-carton-step-answer
                    [active]="state() === 'TENTH'"
                    [typedAnswers]="typedAnswers()"
                    [correct]="stepCartonsCorrect()"
                    [incorrect]="isWrong()"
                    [shaking]="shake()"
                    [answer]="intermediateAnswer()"
                    [value]="tenthsValue()"
                  />
                </div>
              </div>

              @if (['SINGLE', 'CARRY', 'WRITE'].includes(state())) {
                <div
                  [ngClass]="{ 'text-emerald-500': state() === 'SINGLE' }"
                  class="font-family-din grid h-40 w-full grid-cols-4 items-center gap-4 text-8xl"
                >
                  <div class="col-span-3 grid h-full grid-cols-2 items-center gap-2">
                    <div class="text-end">{{ number()[0] + tenths() * 10 }} +</div>
                    <div class="flex h-full w-full items-center gap-2">
                      <div
                        [ngClass]="{
                          'border-b-4': state() === 'SINGLE' || (state() === 'WRITE' && !hasCarry()),
                          'border-transparent!': state() === 'WRITE',
                          'rounded-b-lg': !hasCarry(),
                        }"
                        class="flex h-full w-full items-center justify-end border-4 border-t-0 border-b-0 border-dotted border-white bg-white/30 p-2"
                      >
                        @if (single() > 0) {
                          {{ single() }}
                        } @else {
                          0
                        }
                      </div>
                      <div>=</div>
                    </div>
                  </div>

                  <div class="flex min-w-0 items-center justify-end self-stretch">
                    <rid-egg-carton-step-answer
                      [active]="state() === 'SINGLE'"
                      [typedAnswers]="typedAnswers()"
                      [correct]="stepCartonsCorrect()"
                      [incorrect]="isWrong()"
                      [shaking]="shake()"
                      [answer]="intermediateAnswer()"
                      [value]="singlesValue()"
                    />
                  </div>
                </div>
              }

              @if (['CARRY', 'WRITE'].includes(state()) && hasCarry()) {
                <div
                  [ngClass]="{ 'text-emerald-500': state() === 'CARRY' }"
                  class="font-family-din grid h-40 w-full grid-cols-4 items-center gap-4 text-8xl"
                >
                  <div class="col-span-3 grid h-full grid-cols-2 items-center gap-2">
                    <div class="text-end">{{ singlesValue() }} +</div>
                    <div class="flex h-full w-full items-center gap-2">
                      <div
                        [ngClass]="{ 'border-transparent!': state() === 'WRITE' }"
                        class="flex h-full w-full items-center justify-end rounded-b-lg border-4 border-t-0 border-dotted border-white bg-white/30 p-2"
                      >
                        {{ carry() }}
                      </div>
                      <div>=</div>
                    </div>
                  </div>

                  <div class="flex min-w-0 items-center justify-end self-stretch">
                    <rid-egg-carton-step-answer
                      [active]="state() === 'CARRY'"
                      [typedAnswers]="typedAnswers()"
                      [correct]="stepCartonsCorrect()"
                      [incorrect]="isWrong()"
                      [shaking]="shake()"
                      [answer]="intermediateAnswer()"
                      [value]="carryValue()"
                    />
                  </div>
                </div>
              }
            </div>
          </div>

          <div class="flex flex-col gap-8 border-l-3 border-white/25 pl-16">
            <div class="flex gap-4">
              <rid-button (click)="addCarton()" [disabled]="state() !== 'TENTH'" class="size-fit">+ volle eierdoos</rid-button>
              <rid-button (click)="removeCarton()" [disabled]="tenths() <= 0 || state() !== 'TENTH'" appearance="DANGER" class="size-fit">
                - volle eierdoos
              </rid-button>

              @if (!singlesCartonAdded()) {
                <rid-button (click)="addEmptyCarton()" [disabled]="state() !== 'SINGLE'" class="size-fit">+ lege eierdoos</rid-button>
              }
            </div>

            <div class="grid w-fit grid-flow-col grid-cols-2 grid-rows-5 gap-4 gap-x-6">
              @for (_ of [].constructor(cartons()); track $index) {
                <rid-egg-carton [changeable]="false" [fixedEggs]="10" />
              }

              @for (_ of [].constructor(tenths()); track $index) {
                <rid-egg-carton [changeable]="false" [eggs]="10" [fillColor]="state() === 'TENTH' ? '#10b981' : '#2b7fff'" />
              }

              @if (singlesCartonAdded()) {
                <rid-egg-carton
                  [(eggs)]="singles"
                  [changeable]="state() === 'SINGLE'"
                  [fixedEggs]="number()[0] % 10"
                  [fillColor]="'#2b7fff'"
                />
              }

              @if (hasCarry()) {
                <rid-egg-carton [(eggs)]="carry" [changeable]="state() === 'CARRY'" [fillColor]="'#2b7fff'" />
              }
            </div>
          </div>
        </div>

        @let typedStepEngaged = typedAnswers() && ['TENTH', 'SINGLE', 'CARRY'].includes(state());
        @let typedStepActive = typedStepEngaged && stepCartonsCorrect();

        @if (state() !== 'WRITE' && !typedStepEngaged) {
          <div class="shrink-0">
            <rid-button (click)="next()">Volgende</rid-button>
          </div>
        }

        @if (state() === 'WRITE' || typedStepActive) {
          <div class="absolute bottom-0">
            <div class="bg-surface-100 flex gap-2 rounded-t-md p-2">
              @let currentAnswer = state() === 'WRITE' ? userAnswer() : intermediateAnswer();
              @let expectedLength = state() === 'WRITE' ? answer().toString().length : expectedIntermediate().toString().length;
              @let canSubmit = currentAnswer.length > 0;

              @for (_ of [].constructor(10); track $index) {
                @let disabled = currentAnswer.length === expectedLength;
                <button
                  (click)="addNumber($index)"
                  [disabled]="disabled"
                  [ngClass]="{ 'cursor-not-allowed opacity-75': disabled }"
                  class="bg-card-background border-surface-300 text-text-primary font-lexy2000s grid h-24 w-16 cursor-pointer place-items-center rounded border-2 text-5xl transition-all"
                >
                  {{ $index }}
                </button>
              }

              <button
                (click)="backspace()"
                [disabled]="currentAnswer.length === 0"
                [ngClass]="{ 'cursor-not-allowed opacity-75': currentAnswer.length === 0 }"
                class="font-lexy2000s grid h-24 w-24 cursor-pointer place-items-center rounded border-2 border-red-700 bg-red-500 text-5xl text-white transition-all"
              >
                <i-backspace class="size-10" />
              </button>

              <button
                (click)="submit()"
                [disabled]="!canSubmit"
                [ngClass]="{ 'cursor-not-allowed opacity-75': !canSubmit }"
                class="font-lexy2000s grid h-24 w-24 cursor-pointer place-items-center rounded border-2 border-blue-700 bg-blue-500 text-5xl text-white transition-all"
              >
                <i-enter class="size-10" />
              </button>
            </div>
          </div>
        }
      </div>
    }

    @if (revelation(); as revelation) {
      <rid-modal-background [blur]="true" />
      <rid-correct-answer-modal (continue)="revealWaiter.finish()">
        <h3 class="font-family-din mb-4 text-lg">Het goede antwoord is:</h3>
        <p class="font-family-din text-6xl font-bold">{{ revelation }}</p>
      </rid-correct-answer-modal>
    }
  </rid-mechanic-content>
</rid-mechanic-wrapper>
